import { useCallback, useEffect, useState } from 'react';

export type Theme = 'dark' | 'light';
export const THEME_STORAGE_KEY = 'multimod:theme';

export function readPersistedTheme(): Theme {
  if (typeof localStorage === 'undefined') return 'dark';
  const raw = localStorage.getItem(THEME_STORAGE_KEY);
  return raw === 'light' ? 'light' : 'dark';
}

export function applyTheme(theme: Theme): void {
  if (typeof document === 'undefined') return;
  const html = document.documentElement;
  html.classList.remove('dark', 'light');
  html.classList.add(theme);
}

export function useTheme(): [Theme, (next: Theme) => void] {
  const [theme, setThemeState] = useState<Theme>(readPersistedTheme);

  // Garante que o DOM bate com o state (mount + qualquer mudança).
  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const setTheme = useCallback((next: Theme) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(THEME_STORAGE_KEY, next);
    }
    setThemeState(next);
  }, []);

  return [theme, setTheme];
}
